module.exports = __webpack_public_path__ + "img/goldcoast-map.8f8e7b60.jpg";